export const INVOICE_STATES = [
    { name: 'Paid', label: 'PAID' },
    { name: 'Unpaid', label: 'UNPAID' },
];